import { makeStyles } from '@material-ui/core/styles';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  closeBtn: {
    borderRadius: '2px !important',
    backgroundColor: `${themeColor.white} !important`,
    fontSize: `${vh(2.08)} !important`,
    fontWeight: '500 !important' as any,
    letterSpacing: '1.43px !important',
    lineHeight: '1 !important',
    boxShadow: `0 1px 1px 0 ${themeColor.almosttransparentblack} !important`,
    border: `1px solid ${themeColor.secondaryLight} !important`,
    '&:hover': {
      boxShadow: 'none !important',
      backgroundColor: `${themeColor.white} !important`,
    },
  },
}));
